import React, {useRef, useState} from 'react';
import s from './UserPhoto.module.css';
import {useTranslation} from 'react-i18next';
import {useAddUserPhotoMutation} from '../../../redux/userApi';
import {handleApiCall} from '../../../assets/utils/utils';
import {toast} from 'react-toastify';

const UserPhoto = ({
	userName,
	photo,
}: {
	userName: string;
	photo: string | null;
}) => {
	const {t} = useTranslation();
	const fileInputRef = useRef<HTMLInputElement>(null);
	const [localPhoto, setLocalPhoto] = useState<string | null>(photo);

	const [addPhoto, {isLoading}] = useAddUserPhotoMutation();

	const handleClick = () => {
		fileInputRef.current?.click();
	};

	const handleFileChange = async (
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		const file = event.target.files?.[0];
		if (!file) return;
		await handleApiCall({
			apiCall: () => addPhoto(file),
			onSuccess: (data) => {
				toast.success(data.message.textmsg);
				// Обновляем локальное фото URL с сервера, если он вернулся
				if (data.href) {
					setLocalPhoto(data.href);
				}
			},
		});
	};

	return (
		<div className={s.userPhoto} onClick={handleClick}>
			<input
				ref={fileInputRef}
				type="file"
				accept="image/*"
				onChange={handleFileChange}
				className={s.hiddenInput}
			/>
			{isLoading ? (
				<div className={s.loaderContainer}>
					<div className={s.spinner}></div>
					<span className={s.loadingText}>{t('Завантаження...')}</span>
				</div>
			) : localPhoto ? (
				<div className={s.photoContainer}>
					<img src={localPhoto} alt={userName} className={s.photoImage} />
					<div className={s.uploadOverlay}>
						<span className={s.uploadText}>{t('Змінити фото')}</span>
					</div>
				</div>
			) : (
				<div className={s.userMark}>
					{(userName || '')
						.split(' ')
						.map((n: string, i: number, a: any) =>
							i === 0 || i + 1 === a.length ? n[0] : null,
						)
						.join('')}
					<div className={s.uploadOverlay}>
						<span className={s.uploadText}>{t('Додати фото')}</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default UserPhoto;
